import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ZenchefWidget from "../elements/zenchef-widget";
import CookieBanner from "../elements/cookie";
import { Footer } from "./Footer";
import { MobileMenu } from "./MobileMenu";
import { Navbar } from "./Navbar";
import { NotificationBar } from "./NotificationBar";

function RouteFallback() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" aria-live="polite" aria-busy="true">
      <div className="flex gap-1.5">
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:0ms]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:150ms]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#c9a96e] [animation-delay:300ms]" />
      </div>
    </div>
  );
}

export function Layout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="fixed inset-x-0 top-0 -z-10 h-[32rem] bg-[radial-gradient(circle_at_top,_rgba(244,182,88,0.16),_transparent_40%),linear-gradient(180deg,_rgba(41,84,76,0.12),_transparent_70%)]" />
      <NotificationBar />
      <Navbar
        isMobileMenuOpen={isMobileMenuOpen}
        onToggleMobileMenu={() => setIsMobileMenuOpen((open) => !open)}
      />
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
      <main className="px-4 pb-20 pt-[calc(6rem+var(--notification-bar-h,0px))] sm:px-6 lg:px-8">
        <div className="mx-auto w-full max-w-7xl">
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
      <Footer />
      <ZenchefWidget />
      <CookieBanner />
    </div>
  );
}
